var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRtLoginIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 6.66699L9.13799 7.52892C8.87764 7.78927 8.87764 8.21138 9.13799 8.47173L9.99992 9.33366M9.33325 8.00032L14.6666 8.00033M3.99992 13.3337C2.52716 13.3337 1.33325 12.1398 1.33325 10.667V5.33366C1.33325 3.8609 2.52716 2.66699 3.99992 2.66699M3.99992 13.3337C5.47268 13.3337 6.66658 12.1398 6.66658 10.667V5.33366C6.66658 3.8609 5.47268 2.66699 3.99992 2.66699M3.99992 13.3337H9.33325C10.806 13.3337 11.9999 12.1398 11.9999 10.667M3.99992 2.66699H9.33325C10.806 2.66699 11.9999 3.8609 11.9999 5.33366",
    stroke: "#181D27",
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRtLoginIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/RT_login_icon.d55d50a6959618e152e747421b4dc03a.svg";